import React from 'react';
import PropTypes from 'prop-types';
import { Collapsible, CollapsibleContent, CollapsibleHeader } from '../../../../../components/Collapsible';
import { userCurrencyPropType } from '../FilterHelpers/FilterPropTypes';
import { FilterPrice, FilterPriceForm } from '../../Filter';

const CollapsiblePrice = ({ label, position, min, max, handleDataChange, tracking, userCurrency, isThreeColumnLayout }) => {
  return (
    <CollapsibleContent initialState="open">
      <CollapsibleHeader priority={0}>
        {label}
      </CollapsibleHeader>
      <Collapsible extraClass="collapsible-price">
        {position === 'desktop' ? (
          <FilterPriceForm
            min={min}
            max={max}
            handleDataChange={handleDataChange}
            tracking={tracking}
            userCurrency={userCurrency}
          />
        ) : (
          <FilterPrice
            min={min}
            max={max}
            handleDataChange={handleDataChange}
            tracking={tracking}
            isThreeColumnLayout={isThreeColumnLayout}
            userCurrency={userCurrency}
            position={position}
          />
        )}
      </Collapsible>
    </CollapsibleContent>
  );
};

CollapsiblePrice.propTypes = {
  label: PropTypes.string,
  position: PropTypes.string,
  min: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  max: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  handleDataChange: PropTypes.func,
  tracking: PropTypes.object,
  userCurrency: userCurrencyPropType,
  isThreeColumnLayout: PropTypes.bool
};

export { CollapsiblePrice };
